import { isEmptyString } from './common';

export const hasErrorInNotificationTemplate = (name: string) => {
  return isEmptyString(name);
};